import { Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";

import css from "./cell.module.scss";

type EmptyCellProps = {
  qaId?: string;
};

export const EmptyCell = ({ qaId }: EmptyCellProps) => (
  <Stack className={css.cell} qaId={qaId}>
    <Typography variant="bodyRegular">-</Typography>
  </Stack>
);
